/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect, useRef} from "react";
// reactstrap components

import {  
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col  
} from "reactstrap";
import { useHistory } from 'react-router-dom';
import del from "assets/img/del.png"

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

let session = {};
let imgFile = "";

function PlayerProfile(props) {

  const history = useHistory();
    
  session = JSON.parse(window.sessionStorage.getItem('player'));
    
  const [name, setName] = useState(session['name']); 
  const [nickName, setNickName] = useState(session['nickName']); 
  
  let nowsex = true;
  if(session['sex'] == 0)nowsex = false;     
  const [sex, setSex] = useState(nowsex);

  let birthdaAry = session['birthday'] ? session['birthday'].split("-") : ['2002','01','01'];
  let bl = "";
  let old;
  if(birthdaAry.length > 2){
    bl = birthdaAry[0]+"年"+birthdaAry[1]+"月"+birthdaAry[2]+"日生れ";
    // bl = birthdaAry[1]+"月"+birthdaAry[2]+"日生まれ";
    old = new Date().getFullYear() - birthdaAry[0];
    let tM = new Date().getTime();
    let dateString = new Date().getFullYear()+"-"+("0"+(birthdaAry[1])).slice(-2)+"-"+("0" + birthdaAry[2]).slice(-2);
    let bM = new Date(dateString+'T00:00:00').getTime();
    if(tM <= bM)
      old -= 1;
  }
  const [oldLab, setOldLab] = useState(old);
  const [birthLab, setBirthLab] = useState(bl);

  const [birthday, setBirthday] = useState(session['birthday']);

  const [hight, setHight] = useState(session['hight']);

  const [weight, setWeight] = useState(session['weight']);

  const [school, setSchool] = useState(session['school']);

  const [grade, setGrade] = useState(session['grade']);

  const [post_code, setPost] = useState(session['post_code']);

  const [address, setAddress] = useState(session['address']);

  const [number, setNumber] = useState(session['number']);
  const [lessonClass, setLessonClass] = useState(session['lessonClass']);

  // console.log(session['portfolio']);
  const [portfolio, setPortfolio] = useState(session['portfolio'] || '');

  let numberLab = ['4回','8回','12回','16回','4回','フリー'];


  const [p_proposer, s_setProposerData] = useState([]);
  const [p_opponent, s_setOpponentData] = useState([]);
  const [s_preparation, s_setPreparation] =  useState([]);
  const [s_win, s_setWin] = useState([]);
  const [s_battle, s_setBattle] = useState([]);
  const [s_ranking, s_setRanking] = useState([]);
  const [s_rankings, s_setRankings] = useState([]);
  const [s_winrate, s_setWinrate] = useState([]);
  const [rank, setRank] = useState(0);
  const [to_year, setToYear] = useState(new Date().getFullYear());
  const [to_month, setToMonth] = useState(new Date().getMonth() + 1);
  const [today_ranking, setToDayRanking] = useState(new Date());
  const [uFlag, setUFlag] = useState(0);

  useEffect(() => {
    
    if(session === null){      
      window.location = '/';
    }

    axios.get(URL_API+"getBattleAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {

      if(response.data.length > 0 && Array.isArray(response.data)){
        s_setBattle(response.data); 
      }

    }); 

    axios.get(URL_API+"getnewbig", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {
        setPortfolio((response.data["target1"] ? response.data["target1"] : '')+"<br>"+(response.data["target2"] ? response.data["target2"] : '') +"<br>" + (response.data["target3"] ? response.data["target3"] : '') );
      //}
    }); 
    
    axios.get(URL_API+"getWinrateAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {

      if(response.data.length > 0 && Array.isArray(response.data)){
        s_setWinrate(response.data);

        let winlose = {};
        winlose["lose"] = response.data[response.data.length - 1]["lose"];
        winlose["win"] = response.data[response.data.length - 1]["win"];
        s_setWin(winlose);

      }

    }); 

    axios.get(URL_API+"getMyRankingsAPI", {
      params: {
        user: session['id'], 
        to_year:to_year,
        to_month:to_month
      }
    })
    .then(function (response) {
      // console.log(Object.keys(response.data).length);
      if(Object.keys(response.data).length > 0 && typeof response.data == 'object'){
        s_setRankings(response.data);

        let rankAry = response.data;
        console.log(rankAry);
        for (let idK in rankAry) {
          if(rankAry[idK].title == "関東U18"){
            setRank(rankAry[idK]["value"]);
          }
        }
      }else{
        s_setRankings({});
      }

    });
    
    axios.get(URL_API+"getRankingAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {

      if(response.data.length > 0 && Array.isArray(response.data)){
        s_setRanking(response.data);
        window.sessionStorage.setItem('s_ranking', JSON.stringify(response.data));
      }

    }); 

    if(s_win.win == undefined){
      s_setWin({"win":0, "lose":0});
    }

    // s_setProposerData(JSON.parse(window.sessionStorage.getItem("p_proposer")));
    axios.get(URL_API+"getPreparaListAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {
    
      if(response.data.length > 0 && Array.isArray(response.data)){
        s_setProposerData(response.data);
        // window.sessionStorage.setItem('p_proposer', JSON.stringify(response.data));
      }

    }); 
    
    // s_setOpponentData(JSON.parse(window.sessionStorage.getItem("p_opponent")));
    axios.get(URL_API+"getOpponentListAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {
      
      if(response.data.length > 0 && Array.isArray(response.data)){
        s_setOpponentData(response.data);
        // window.sessionStorage.setItem('p_opponent', JSON.stringify(response.data));
      }
    });  
    
    //サーブ
    // s_setPreparation(JSON.parse(window.sessionStorage.getItem("s_preparation")));
    axios.get(URL_API+"getNowPreparaListAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {

      if(response.data.length > 0 && Array.isArray(response.data)){       
        s_setPreparation(response.data);       
        // window.sessionStorage.setItem('s_preparation', JSON.stringify(response.data));
      }

    }); 

  }, []);
  
  

  // const [selectedFile, setSelectedFile] = React.useState(null);
  const inputElement = useRef();
  const [selectedFile, setSelectedFile] = useState(session['profile_photo_path']);
  // const [imgFile1, setImgFile1] = useState('');   

  const tobackPage = (e) => {
    history.push('../coach/userMg');
  }

  const onChangeYear = (e) => {
    setToYear(e.target.value);
    axios.get(URL_API+"getMyRankingsAPI", {
      params: {
        user: session['id'], 
        to_year:e.target.value,
        to_month:to_month
      }
    })
    .then(function (response) {
      setUFlag((c) => c + 1);
      if(Object.keys(response.data).length > 0 && typeof response.data == 'object'){
        s_setRankings(response.data);

        let rankAry = response.data;

        for (let idK in rankAry) {
          if(rankAry[idK].title == "関東U18"){
            setRank(rankAry[idK]["value"]);
          }
        }
      }else{
        s_setRankings({});
      }
      setUFlag((c) => c + 1);
    }); 
  }

  const onChangeMonth = (e) => {
    setToMonth(e.target.value);
    axios.get(URL_API+"getMyRankingsAPI", {
      params: {
        user: session['id'], 
        to_year:to_year,
        to_month:e.target.value
      }
    })
    .then(function (response) {
      setUFlag((c) => c + 1);
      if(Object.keys(response.data).length > 0 && typeof response.data == 'object'){
        s_setRankings(response.data);

        let rankAry = response.data;

        for (let idK in rankAry) {
          if(rankAry[idK].title == "関東U18"){
            setRank(rankAry[idK]["value"]);
          }
        }
      }else{
        s_setRankings({});
      }
      setUFlag((c) => c + 1);
    }); 
  }

  const renderYears = (y) => {
    let years = [];
    for(var i=(y-5);i<=y;i++){
      years.push(i);
    }
    return years;
  }

  const renderMonths = (m) => {
    let months = [];
    for(var i=1;i<=12;i++){
      months.push(i);
    }
    return months;
  }

  const showChart = (e) => {
    history.push('../parent/rankingChart');
  }

  return (
    <>
        <Row className="px-0 mx-0">
          <Col className="colp col-12">
            <Card className="card-user">
              <CardBody>
                <Row>
                  <Col className="col-5 col-md-3 text-right" style={{position:'relative'}} >
                    <img
                      alt="..."
                      className="avatar border-gray my-0"                      
                      src={
                       selectedFile ? "https://xs458763.xsrv.jp/uploads/"+selectedFile : require("assets/img/mike.png").default}
                    />
                  </Col>
                  <Col className="col-7 col-md-9 text-left" >    
                    <div className="pt-2" style={{fontSize: '18px', fontWeight: 'bold', color: 'rgb(3, 115, 202)'}}>
                      大きな目標（夢）は
                    </div> 
                    <div className="pt-2" style={{fontSize: '18px', fontWeight: '700', color: 'rgb(36 160 216)'}} dangerouslySetInnerHTML={{__html: portfolio || ''}}/>           
                  </Col>
                </Row>              
              </CardBody>
              <CardFooter>
                <hr />
                <div className="button-container">
                  <Row>
                    <Col className="col-5 px-1" >
                      <h5>
                        <small>{birthLab == null ? '' : birthLab}</small><br />
                        {oldLab == null ? '' : oldLab}才
                      </h5>
                    </Col>
                    <Col className="col-4">
                      <h5>
                        <small>身長 / 体重</small><br />
                        {hight == null ? '' : hight}cm {weight == null ? '' : weight}kg                        
                      </h5>
                    </Col>
                    <Col className="col-3">
                      <h5>
                        <small>受講回数</small><br />
                        {number == null ? '' : numberLab[number]}                       
                      </h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="col-5 px-1" >
                      <h5>
                        <small>関東U18 Rank</small><br />
                        {rank}                       
                      </h5>
                    </Col>
                    <Col className="col-4" >
                      <h5>
                        <small>2022　W-L </small><br />
                        {s_win.win} : {s_win.lose}                        
                      </h5>
                    </Col>
                    <Col className="col-3" >
                      <h5>
                        <small>勝率</small><br />
                        {s_win.win + s_win.lose === 0? 0 : Math.round(s_win.win / (s_win.win + s_win.lose) * 100)}％                       
                      </h5>
                    </Col>
                  </Row>
                </div>
              </CardFooter>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h6" className="text-left">近日予定の試合</CardTitle>
              </CardHeader>
              <CardBody>
              {
                s_preparation?.map((tmp, index) =>                    
                  <Row key={index} style={{alignItems: 'center'}}>
                    <Col className="col-3">{tmp['tourdate']}</Col>
                    <Col className="col-3" style={{padding:'0px'}}>{tmp['tournament']}</Col>
                    <Col className="col-2" style={{padding:'0px'}}>目標</Col>
                    <Col className="col-4" style={{padding:'5px'}}>
              
                      <select className="form-control"
                        value={tmp['target']}                
                        id={"target_"+ index}
                        name={"target_"+index}
                         readOnly="readonly"
                          style={{backgroundColor:'white'}}
                      >
                        <option value="0">優勝</option>
                        <option value="1">準優勝</option>
                        <option value="2">ベスト4</option>
                        <option value="3">ベスト8</option>
                        <option value="4">ベスト16</option>
                      </select>
                    </Col>
                  </Row>
                )
              } 
                                 
              </CardBody>
            </Card>
          </Col>
          <Col className="colp col-12">
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h6" className="text-left">プロフィール編集</CardTitle>
              </CardHeader>
              <CardBody className="text-left">
                <Form>
                  <Row>                     
                    <Col className="col-12">
                      <FormGroup>
                        <label>名字 </label>
                        <Input type="text" readOnly="readonly" style={{backgroundColor:'white'}} value={nickName == null ? '' : nickName}/>
                      </FormGroup>
                    </Col>               
                    <Col className="col-12">
                      <FormGroup>
                        <label>名前 </label>
                        <Input type="text" readOnly="readonly" value={name == null ? '' : name} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>                  
                    <Col className="col-12">
                      <FormGroup>
                        <label>性別</label><br/>                        
                        <div className="toggle-switch">
                          <input
                            type="checkbox"
                            className="toggle-switch-checkbox"
                            name="toggle"
                            id="toggle"
                            checked={sex}
                            readOnly="readonly"
                             style={{backgroundColor:'white'}}
                          />
                          <label className="toggle-switch-label" htmlFor="toggle">
                            <span className="toggle-switch-inner" />
                            <span className="toggle-switch-switch" />
                          </label>
                        </div>                        
                      </FormGroup>
                    </Col>                                      
                    <Col className="col-12">
                      <FormGroup>
                        <label>生年月日</label>
                        <Input type="date" readOnly="readonly" value={birthday == null ? '' : birthday} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>  
                  </Row>
                  <Row>                
                    <Col className="col-12">
                      <FormGroup>
                        <label>身長</label>
                        <Input type="number" readOnly="readonly" value={hight == null ? '' : hight} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>                                   
                    <Col className="col-12">
                      <FormGroup>
                        <label>体重</label>
                        <Input type="number" readOnly="readonly" value={weight == null ? '' : weight} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>                  
                    <Col className="col-12">
                      <FormGroup>
                        <label>学校</label>
                        <Input type="text" readOnly="readonly" value={school == null ? '' : school} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>                    
                    <Col className="col-12">
                      <FormGroup>
                        <label>学年</label>
                        <Input type="number" readOnly="readonly" value={grade == null ? '' : grade} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>                  
                    <Col className="col-12">
                      <FormGroup>
                        <label>郵便番号</label>
                        <Input type="text" readOnly="readonly" value={post_code == null ? '' : post_code} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col>
                                    
                    <Col className="col-12">
                      <FormGroup>
                        <label>住所</label>
                        <Input type="text" readOnly="readonly" value={address == null ? '' : address} style={{backgroundColor:'white'}}/>
                      </FormGroup>
                    </Col> 
                  </Row>
                  <Row>                   
                    <Col className="col-12">
                      <FormGroup>
                        <label>受講回数</label>                        
                        <select className="form-control"
                          value={number == null ? '' : number} 
                           readOnly="readonly" 
                            style={{backgroundColor:'white'}}
                        >
                          <option value="0">4回</option>
                          <option value="1">8回</option>
                          <option value="2">12回</option>
                          <option value="3">16回</option>
                          <option value="4">フリー</option>
                        </select>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>                   
                    <Col className="col-12">
                      <FormGroup>
                        <label>クラス</label>
                        <select className="form-control"
                          value={lessonClass == null ? '' : lessonClass} 
                           readOnly="readonly" 
                            style={{backgroundColor:'white'}}
                        >
                          <option value="0">Aプレイヤーズ</option>
                          <option value="1">Bプレイヤーズ</option>
                        </select>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form> 
              </CardBody>   
            </Card>
            <Card className="card-user mb-0">
              <CardBody>
                <Form>
                  <Row>                    
                    <Col  className="col-12">
                      <FormGroup>  
                        <Row>
                          <Col className="col-12">
                            <input type="button" name="user" value="主な戦績" className="btn-round btn btn-danger"/>
                          </Col>
                        </Row>    
                        {
                        s_battle.map((battle, index) =>
                          <Row key={index } style={{marginBottom:'3px'}}>
                            <Col className="col-12">
                              <Input placeholder="ex : 2019年関東ジュニアベスト４" type="text" value={battle.content == null ? '' : battle.content} readOnly="readonly" style={{backgroundColor:'white'}}/>
                            </Col>
                          </Row>
                        )}
                      </FormGroup>
                    </Col>                                     
                  </Row>
                  <Row>                    
                    <Col  className="col-12">
                      <FormGroup>  
                        <Row>
                          <Col className="col-12">
                            <input type="button" name="user" value="ランキング" className="btn-round btn btn-danger"/>
                          </Col>
                        </Row>    
                        <Row className="mb-2 d-flex">
                          <Col className="col-8 d-flex">
                            <div className="col-7 d-flex px-1 align-items-center" style={{height:'30px'}}>
                              <select className="col-10 px-0" style={{height:'30px'}}
                                value={to_year}                                           
                                onChange={(e) => onChangeYear(e)}
                              >
                              {
                                renderYears(2022).map((y, idx) => 
                                    (<option key={idx} value={y}>{y}</option>)
                                )
                              }
                              </select>年
                            </div>
                            <div className="col-5 d-flex px-1 align-items-center" style={{height:'30px'}}>
                              <select className="col-10 px-0" style={{height:'30px'}}
                                value={to_month}                                           
                                onChange={(e) => onChangeMonth(e)}
                              >
                              {
                                renderMonths(to_month).map((m, idx) => 
                                    (<option key={idx} value={m}>{m}</option>)
                                )
                              }
                              </select>月
                            </div>
                          </Col>
                          <Col className="col-3 px-0 text-right" style={{height:'30px'}}>
                            <i className="fas fa-chart-line" onClick={(event) => showChart(event)} style={{fontSize:'30px'}}></i>
                          </Col>
                        </Row>
                        {
                        s_ranking.map((ranking, index) =>
                          <Row key={index}>
                            <Col className="col-8"  style={{paddingRight:'0px'}}>
                              <Input placeholder="ex : 埼玉U〇〇" readOnly="readonly" type="text" value={ranking.title == null ? '' : ranking.title} style={{backgroundColor:'white'}}/>
                            </Col>
                            <Col className="col-4" style={{paddingLeft:'0px'}}>
                              <Input placeholder="" readOnly="readonly" type="number" value={s_rankings[ranking.id] ? s_rankings[ranking.id].value : ''} style={{backgroundColor:'white'}}/>
                            </Col>
                          </Row>
                        )}
                      </FormGroup>
                    </Col>                                     
                  </Row>
                  <Row>                    
                    <Col  className="col-12">
                      <FormGroup>  
                        <Row>
                          <Col className="col-12">                           
                            <input type="button" name="user" value="勝率" className="btn-round btn btn-danger" />
                          </Col>
                        </Row>  
                        <Row className="text-left">
                          <Col className="col-6">
                            <b>カテゴリー</b>
                          </Col>
                          <Col className="col-3">
                            <b>W-L</b>
                          </Col>
                          <Col className="col-3">
                            <b>%</b>
                          </Col>                              
                        </Row>    
                        {
                        s_winrate.map((winrate, index) =>
                          <Row className={'text-left'+(winrate["surface"] == 'Total' ? '_total' : '')} key={index }>
                            <Col className="col-6">
                              {winrate["surface"]}
                            </Col>
                            <Col className="col-3">
                              {winrate["win"]} - {winrate["lose"]}
                            </Col>
                            <Col className="col-3">
                              {(winrate["win"] + winrate["lose"]) === 0? 0 : Math.round(winrate["win"] / (winrate["win"] + winrate["lose"]) * 100)}%
                            </Col>
                          </Row>
                        )}
                      </FormGroup>
                    </Col>                                     
                  </Row>
                  {/*<Row>                    
                                      <Col className="px-1">
                                        <FormGroup>                         
                                          <textarea className="form-control" id="remark" readOnly="readonly" style={{backgroundColor:'white'}} value={portfolio} type='text'></textarea>                        
                                        </FormGroup>
                                      </Col>                                     
                                    </Row>*/}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
    </>
  );
}
export default PlayerProfile;
